import { Injectable } from '@angular/core';
import { Observable } from "rxjs";
import { BlobResponse } from '../../Models/OtherClasses';
import { BaseService } from "../BaseService";
import { UrlService } from "../UrlService";

@Injectable()
export class StatsService {
	private url: string;

	constructor(
		private myBaseService: BaseService,
		private urlService: UrlService
	){
		this.url = urlService.getURL('Stats');
	}
	
	getStats(searchObj: ePM.Logic.DateSearch, all: boolean): Observable<{ [key: string]: any[]; }> {
		return this.myBaseService.post(searchObj, this.url + '?all=' + (all || false));
	}
	getDetails(searchObj: ePM.Logic.DateSearch, type: string, all: boolean) : Observable<[]> {
		return this.myBaseService.post(searchObj, this.url + '/Details?type=' + (type || '') + '&all=' + (all || false));
	}
	exportDetails(searchObj: ePM.Logic.DateSearch, type: string, all: boolean): Observable<BlobResponse> {
		return this.myBaseService.returnBlob(searchObj, this.url + '/Details?type=' + (type || '') + '&export=true&all=' + (all || false));
	}
	getReportChoices(): Observable<any[]> {
		return this.myBaseService.loadAll(this.url + '/ReportChoices');
	}
	exportReport(searchObj: ePM.Logic.ReportSearch): Observable<BlobResponse> {
		return this.myBaseService.returnBlob(searchObj, this.url + '/Report');
	}

	exportCECreditReport(searchObj: ePM.Logic.DateSearch, ExcludeTerminated: boolean): Observable<BlobResponse> {
		return this.myBaseService.returnBlob(searchObj, this.url + '/CECreditReport?excludeTerminated=' + (ExcludeTerminated ?? false).toString());
	}
}				